<template>
  <div class="wv100 hv100" style="background-color: #f6f6f6">
    <div class="flex-column" style="background-color: #fff">
      <!--      <label>地区：<input v-model="location"/></label>-->
      <div style="background-color: #ffffff;padding-top: 0.2rem;padding-bottom: 0.2rem">
        <div class="search flex-row justify-content-start">
          <div
              class="search-left flex-column justify-content-center align-items-center"
          >
            <i class="el-icon-search"></i>
          </div>
          <div class="search-main flex-column justify-content-center">
            <input v-model="keyword" type="text" placeholder="请输入地址关键词"/>
            <!--          <el-input v-model="input" placeholder="请输入活动关键词"></el-input>-->
          </div>
        </div>
      </div>
    </div>
    <div class="flex-column justify-content-center align-items-center">
      <div v-for="(item,index) in markers" :key="index"
           class="flex-row justify-content-start align-items-center map-item"
           @click="clickAddress($event,item)">
        <h1>{{ initAddress(item) }}</h1>
      </div>
    </div>
    <baidu-map>
<!--      <bm-view class="map"></bm-view>-->
      <bm-local-search :keyword="keyword" :panel="false" :auto-viewport="true" :location="location"
                       @searchcomplete="searchcomplete"
      >
<!--        <template>-->
<!--          <bm-marker :position="item" :dragging="false" @click="infoWindowOpen"-->
<!--                     v-for="(item,index) in markers" :key="index"-->
<!--          >-->
<!--            <bm-info-window :show="item.show" @close="infoWindowClose" @open="infoWindowOpen">我爱北京天安门</bm-info-window>-->
<!--          </bm-marker>-->
<!--        </template>-->
      </bm-local-search>
    </baidu-map>
  </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";

import BmView from "vue-baidu-map/components/map/MapView"; //地图视图

import BmLocalSearch from "vue-baidu-map/components/search/LocalSearch"; //搜索

export default {
  components: {
    BaiduMap,
    BmView,
    BmLocalSearch,
  },

  data() {
    return {
      show: false,
      location: '内蒙古',
      keyword: '',
      markers:[]
    };
  },
  props: {
    selectAddress: {
      type: Function,
      defaults: ""
    }
  },
  methods: {
    initAddress(item) {
      item.descAddress = "";
      if (item.address.indexOf(item.province) === -1) {
        item.descAddress += item.province;
      }
      if (item.address.indexOf(item.city) === -1) {
        item.descAddress += item.city;
      }
      item.descAddress += item.address;
      item.descAddress += item.title
      return item.descAddress;
    },
    clickAddress($event, item) {
      item.descAddress = "";
      if (item.address.indexOf(item.province) === -1) {
        item.descAddress += item.province;
      }
      if (item.address.indexOf(item.city) === -1) {
        item.descAddress += item.city;
      }
      item.descAddress += item.address;
      item.descAddress += item.title
      this.$emit("selectAddress", item);
    },
    clear() {
    },
    showPanel() {
      //点击标注出现弹框
      this.isShowPanel = !this.isShowPanel;
    },

    infoWindowClose() {
      //弹框关闭
      this.infoWindow.show = false;
      this.isShowInfo = false;
    },

    infoWindowOpen($event, item) {
      //弹框打开
      item.showInfo = true;
      this.infoWindow.show = true;
      this.isShowInfo = true;
    },

    dragend(val) {
      //标注拖拽完成获取坐标信息

      this.markerPo = val.point;

      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(val.point, rs => {
        this.address = rs.address;
      });
    },

    searchcomplete(arr) {
      if (arr && arr.Yr) {
        this.markers = arr.Yr;
      } else {
        this.markers = undefined;
      }
      this.isShowPanel = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/flex.css";

.search-left {
  width: 0.7rem;
  font-size: 0.4rem;
}
.search-main{

}
.map-item {
  margin-top: 5px;
  background-color: #fff;
  width: 100%;
  min-height: 0.6rem;
  padding: 5px 20px 5px 20px;
}

.search {
  border-radius: 0.1rem;
  border-width: 1px;
  border-style: solid;
  border-color: #2f78df;
  background-color: #ffffff;
  color: #0ba6fa;
  height: 0.8rem;
  margin: 0 0.33rem 0 0.33rem;
}

.map {
  width: 100%;

  height: 500px;
}

.more_panel {
  text-align: center;

  font-size: 12px;

  color: #2878ff;

  padding-top: 10px;

  span {
    cursor: pointer;

    i {
      transform: rotate(90deg);
    }
  }

  span.down {
    i {
      transform: rotate(-90deg);
    }
  }
}
</style>
